// Module Federation requires the entry point to be a dynamic import
// so that shared dependencies are properly negotiated before app code loads.
// Config loading (siteLocation + layersConfig) now happens post-auth in
// <ConfigGate> (see app/index.tsx), which gates the app tree until the config
// store is populated — it no longer runs at bootstrap time.
import('./bootstrap').catch(err => {
    document.body.innerHTML = `<div style="padding:2rem;font-family:sans-serif;color:#c00">
        <h1>Failed to load application</h1>
        <pre>${err.message}</pre>
    </div>`
    // eslint-disable-next-line no-console -- critical bootstrap failure must be logged
    console.error('Bootstrap failed:', err)
})
